import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StateService } from '../../main-layout/state/state.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { BaseClass } from '../../utility/baseClass';
import { Utilityservice } from '../../utility/utilityservice.service';

@Component({
  selector: 'app-statemodal',
  templateUrl: './statemodal.component.html',
  styleUrls: ['./statemodal.component.css']
})
export class StatemodalComponent extends BaseClass implements OnInit {
  saveTitle = 'Add'
  isEdit: boolean = false;
  newstateupdate: any;
  stateDetails: any = {};
  stateForm: FormGroup;
  CSRFToken = "";
  stateid = null;
  newstate: any;
  onlyView: any;
  countryOptions: any;
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]
  constructor(
    public override  injector: Injector,
    private StateService: StateService,
    private formBuilder: FormBuilder,
    public router: Router,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
     private utilityservice:Utilityservice
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.gettoken();
    if (dataFromParent?.title == 'Modify State') {
      this.saveTitle = 'Modify'
      this.isEdit = true;
      this.stateDetails = dataFromParent.datas
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getData();
    this.loadCountries();
  }

  loadCountries() {
    this.StateService.getCountry().subscribe(result => {
      result.sort((a, b) => {
        return a.countryname.localeCompare(b.countryname);
      });
      this.countryOptions = result;
    });
  }

  patchValueForms(data) {
    this.stateid = data[0].stateid;
    this.stateForm.patchValue({ 'stateid': data[0].stateid });
    this.stateForm.patchValue({ 'statename': data[0].statename });
    this.stateForm.patchValue({ 'activeflag': data[0].activeflag });
    this.stateForm.patchValue({ 'countryid': data[0].countryid });
  }

  getData() {
    if (this.stateDetails.length !== undefined) {
      this.patchValueForms(this.stateDetails)
    }
  }


  formInitiliaze() {

    this.stateForm = this.formBuilder.group({
      statename: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(500),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)])],
      countryid: ['', Validators.required],
      activeflag: ['Y']
    })
  }
  gettoken() { 
    this.CSRFToken='';
             this.utilityservice.getCSRFtoken().subscribe(res=>{
             this.CSRFToken=res.csrf;
            },error=>{
              Swal.fire(error.error.message,'','error');
            });
  }

  public validation_message = {
    countryid: [
      { type: 'required', message: 'Country is required' }],
    statename: [
      { type: 'required', message: 'State is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' ).' },
      { type: 'placeholder', message: 'Enter State' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ]
  }
  addState() {
    const payload = {
      statename: this.stateForm.get('statename').value,
      countryid: this.stateForm.get('countryid').value,
      activeflag: "Y",
      csrftoken: this.CSRFToken,
    }; 
    if (this.saveTitle === 'Modify') {
      this.modifyState(payload);
    } else {
      if (this.stateForm.invalid) {
        this.validateAllFormFields(this.stateForm);
      } else {
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Add",
          denyButtonText: `Don't Save`,
        }).then((value) => {
          if (value.isConfirmed) {
            this.StateService.addState(payload).subscribe({
              next: (data) => {
                this.newstate = data;
                if (this.newstate.response === 'exists') {
                  Swal.fire("State already exists!", "", "error").then(() => {
                    this.ref.close();
                  });
                } else {
                  Swal.fire("State is added successfully!", "", "success").then(() => {
                    this.ref.close();
                  });
                }
              },
              error: (error) => {
                Swal.fire({
                  title: "Error Saving State",
                  text: error.error.message || "An unexpected error occurred.",
                  icon: "error",
                });
              },
            });
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
            this.ref.close();
          }
        });
      }
    }
  }

  modifyState(data: any) {

    data["stateid"] = this.stateid;
    data["activeflag"] = this.stateForm.get('activeflag').value;
    if (this.stateForm.invalid) {
      this.validateAllFormFields(this.stateForm);
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`,
      }).then((value) => {
        if (value.isConfirmed) {
          this.StateService.modifyState(data).subscribe({
            next: (response) => {
              this.newstateupdate = response;
              if (this.newstateupdate.response === 'exists') {
                Swal.fire("State already exists!", "", "error").then(() => {
                  this.ref.close();
                });
              } else {
                Swal.fire("State is modified successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
              Swal.fire({
                title: "Error Saving State",
                text: error.error.message || "An unexpected error occurred.",
                icon: "error",
              });
            },
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();
        }
      });
    }
  }
}
